import React from 'react';
import styled from 'styled-components';
import { IProductsGroup } from 'Modules/Shops/types';
import { mediaMdDown, mediaSmDown } from 'theme/helpers/css';
import Slider, { EnumArrowType } from 'Components/Slider';
import BlockContainer from 'Components/landings/BlockContainer';

export const GROUPS_LOGO_LIST_TEST_ID = 'GROUPS_LOGO_LIST_TEST_ID';
export const GROUPS_LOGO_ITEM_TEST_ID = 'GROUPS_LOGO_ITEM_TEST_ID';

const SLIDER_ITEM_WIDTH_LG = 158;
const SLIDER_ITEM_WIDTH_SM = 128;
const SLIDER_ITEM_WIDTH_XS = 59;

const GroupsContainer = styled(BlockContainer).attrs({
  pt: { xs: 4, sm: 6, lg: 7 },
  pb: { xs: 4.5, sm: 7, lg: 8 },
  px: { xs: 1, sm: 13, lg: 30, xl: 40 },
})`
  flex: 0 0 auto;
`;

const Wrapper = styled.div`
  position: relative;
  padding: 0 56px;
  margin: 0 -14px;

  ${mediaSmDown`
      padding-right: 36px;
      padding-left: 36px;
      margin: 0;
    `}
`;

interface IStyledSlider {
  $groupsLength: number;
}

const StyledSlider = styled(Slider)<IStyledSlider>`
  position: static;
  margin: 0 auto;

  .flickity-prev-next-button {
    ${mediaSmDown`
      width: 40px;
      height: 30px;
      top: 36%;
    `}
  }

  ${({ $groupsLength }) => `
    max-width: ${$groupsLength * SLIDER_ITEM_WIDTH_LG - 1}px;
  `};

  ${mediaMdDown`
    ${({ $groupsLength }: IStyledSlider) => `
      max-width: ${$groupsLength * SLIDER_ITEM_WIDTH_SM - 1}px;
    `};
  `}

  ${mediaSmDown`

    ${({ $groupsLength }: IStyledSlider) => `
      max-width: ${$groupsLength * SLIDER_ITEM_WIDTH_XS - 1}px;
    `};
  `}
`;

export const ShopGroupItem = styled.div<{ imageSrc: string }>`
  box-sizing: border-box;
  margin-right: 5px;
  width: ${SLIDER_ITEM_WIDTH_LG}px;
  height: 34px;
  background-image: url(${({ imageSrc }) => imageSrc});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;

  ${mediaMdDown`
    max-width: ${SLIDER_ITEM_WIDTH_SM}px;
    margin-right: 28px;
  `}

  ${mediaSmDown`
    max-width: ${SLIDER_ITEM_WIDTH_XS}px;
    height: 22px;
  `}
`;

interface IGroupsSlider {
  groups?: IProductsGroup[];
}

const GroupsSlider: React.FC<IGroupsSlider> = ({ groups }) => {
  if (!groups?.length) {
    return null;
  }

  return (
    <GroupsContainer>
      <Wrapper data-testid={GROUPS_LOGO_LIST_TEST_ID}>
        <StyledSlider
          withArrows
          arrowType={EnumArrowType.simple}
          infinite={true}
          resize={true}
          $groupsLength={groups.length}
        >
          {groups.map(({ seo_name, logo }) => (
            <ShopGroupItem data-testid={GROUPS_LOGO_ITEM_TEST_ID} key={seo_name} imageSrc={logo.logo_shop_path} />
          ))}
        </StyledSlider>
      </Wrapper>
    </GroupsContainer>
  );
};

export default GroupsSlider;
